import { overrideFilters } from 'app/marketplace/filter/actions';
import { getFilterObject } from 'app/marketplace/filter/utils';
import {
  getMakePage,
  getModelPage,
  getValidSeoPage,
  getVariantPage,
} from 'app/marketplace/contentful/spaces/seo/utils';
import { WEB_APP_URL } from 'app/config';
import { getVehicles } from 'app/marketplace/search/actions';

export const updateFilters = (make, model, variant) => {
  const makeId = make?.id;
  const modelId = model?.id;
  const variantId = encodeURI(variant?.id);

  return overrideFilters({
    make: make
      ? [
          getFilterObject({
            category: 'make',
            label: make?.title,
            value: makeId,
          }),
        ]
      : [],
    model: model
      ? [
          getFilterObject({
            category: 'model',
            label: model?.title,
            value: `${makeId}_${modelId}`,
          }),
        ]
      : [],
    trim: variant
      ? [
          getFilterObject({
            category: 'trim',
            label: variant.title,
            value: `${makeId}_${modelId}_${variantId}`,
          }),
        ]
      : [],
  });
};

export const getVariantPageData = async ({
  dispatch,
  makePath,
  isPreviewContentful,
  isStaging,
  modelPath,
  variantPath,
}) => {
  const response = await Promise.all([
    getMakePage({
      dispatch,
      makePath,
      isStaging,
      WEB_APP_URL,
      isPreviewContentful,
      select: 'fields.title,fields.id,fields.path,fields.logoImages',
    }),
    getModelPage({
      dispatch,
      makePath,
      modelPath,
      isStaging,
      isPreviewContentful,
      select: 'fields.title,fields.id,fields.path,fields.variants',
    }),
    getVariantPage({
      dispatch,
      makePath,
      modelPath,
      variantPath,
      isStaging,
      isPreviewContentful,
    }),
  ]);

  const [makePageResponse, modelPageResponse, variantPageResponse] = response;
  const validMakePage = getValidSeoPage(makePageResponse);
  const validModelPage = getValidSeoPage(modelPageResponse);
  const validVariantPage = getValidSeoPage(variantPageResponse);

  if (validMakePage && validModelPage && validVariantPage) {
    await dispatch(
      updateFilters(validMakePage, validModelPage, validVariantPage),
    );
    await dispatch(getVehicles());
  }
};
